import { FieldStackedLabel } from '../../../Field'
import { FormFieldSelectNG } from '../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { InputField } from '../../../Input'
import { PhoneSelectFormikField } from '../../../Phone'
import { InputAsyncSelect, InputSelectControl } from '../../../Select'
import { TextareaOutlineField } from '../../../Textarea'
import {
  isInfoCurrencyField,
  isInfoDateField,
  isInfoPhoneField,
  isInfoSelectField,
} from '../ProfileInfoWidget.utils'
import {
  focusInfoSelectSearchInputAfterOpen,
  toInfoSelectOptions,
} from '../ProfileInfoWidget.utils.form'
import { ProfileInfoWidgetCurrencyField } from '../ProfileInfoWidgetCurrencyField'
import { ProfileInfoWidgetDateField } from '../ProfileInfoWidgetDateField'
import { ProfileInfoWidgetSelectControlContent } from '../ProfileInfoWidgetSelectControlContent'

import { SINGLE_LINE_TYPES } from './ProfileInfoWidgetFormField.constants'

function ProfileInfoWidgetFormField({ field, options }) {
  const {
    getOptionsData,
    getOptionsDataItems,
    label,
    maxLength,
    name,
    optionLabelKey,
    placeholder,
    toOptions,
    type,
  } = field

  function toPreparedOptions(items) {
    return toInfoSelectOptions(items, optionLabelKey)
  }

  if (isInfoSelectField(type)) {
    return (
      <FormikField
        Component={FormFieldSelectNG}
        Control={InputSelectControl}
        Field={FieldStackedLabel}
        Select={InputAsyncSelect}
        controlProps={{
          Content: ProfileInfoWidgetSelectControlContent,
          onFocusAfterOpen: focusInfoSelectSearchInputAfterOpen,
        }}
        emptyValue={null}
        fieldComponentProps={{ label }}
        getData={getOptionsData}
        getDataItems={getOptionsDataItems}
        getErrorProps={getFormikFormFieldErrorProps}
        name={name}
        toPreparedItems={toOptions ?? toPreparedOptions}
      />
    )
  }

  if (isInfoCurrencyField(type)) {
    return (
      <FormikField
        Component={ProfileInfoWidgetCurrencyField}
        Field={FieldStackedLabel}
        currencyOptions={options?.currency}
        emptyValue={null}
        fieldComponentProps={{ label }}
        getErrorProps={getFormikFormFieldErrorProps}
        name={name}
      />
    )
  }

  // The date input renders its own label and error, so it keeps the default
  // `getErrorProps` and takes the label through the stacked field only
  if (isInfoDateField(type)) {
    return (
      <FormikField
        Component={ProfileInfoWidgetDateField}
        Field={FieldStackedLabel}
        emptyValue={null}
        fieldComponentProps={{ label }}
        name={name}
        placeholder={placeholder}
      />
    )
  }

  if (isInfoPhoneField(type)) {
    return (
      <PhoneSelectFormikField
        Field={FieldStackedLabel}
        controlProps={{ borderless: false }}
        fieldComponentProps={{ label }}
        name={name}
      />
    )
  }

  // `InputField` renders `errorText`, so it keeps the default `getErrorProps`
  if (SINGLE_LINE_TYPES.includes(type)) {
    return (
      <FormikField
        Component={InputField}
        label={label}
        maxLength={maxLength}
        name={name}
      />
    )
  }

  return (
    <FormikField
      clearable
      withoutManualResize
      Component={TextareaOutlineField}
      getErrorProps={getFormikFormFieldErrorProps}
      label={label}
      maxLength={maxLength}
      name={name}
    />
  )
}

export default ProfileInfoWidgetFormField
